module.exports = __webpack_public_path__ + "static/media/game-gameinfobutton.3ebf04e1.png";